export default function formatCnpj(value: string) {
  const normalized = value.toUpperCase().replace(/[./-]/g, '');

  const groups = normalized.match(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
  );

  if (!groups) {
    return value;
  }

  return `${groups[1]}.${groups[2]}.${groups[3]}/${groups[4]}-${groups[5]}`;
}
